export default __webpack_public_path__ + "static/media/plain-sticker-v.ce6294f5.png";